/**
 * Common constants and functions among search scripts.
 */

export const searchQueryStringKeys = {
	queryText: 'queryText',
	page: 'page',
	categories: 'categories',
	segment: 'segment',
	childOnly: 'childOnly',
};

export const priceListQueryStringKey = {
	queryText: 'queryText',
	type: 'type',
	commodity: 'commodity',
	region: 'region',
	district: 'county',
	year: 'year',
	page: 'page',
	searchType: 'searchType',
	product: 'product',
};

export const bussinessEnergyQueryStringKeys = {
	categoryName: 'categoryName',
	pageIndex: 'pageIndex',
	pageSize: 'pageSize',
};

/**
 * Sets the key-value search parameters to the urlSearchParams object.
 *
 * If either of key-value is null, the key will be deleted from search params.
 *
 * @param {URLSearchParams} urlSearchParams Search params object
 * @param {string} key
 * @param {string} value
 */
export function setSearchParam(urlSearchParams, key, value) {
	if (key && value) {
		urlSearchParams.set(key, value);
	} else {
		urlSearchParams.delete(key);
	}
}

/**
 * Builds URL from the base and the search parameters.
 * @param {string} baseUrl Base URL not ending with slash
 * @param {URLSearchParams} urlSearchParams Search parameters
 * @returns {string} Base URL concatenated with search parameters
 */
export function buildUrl(baseUrl, urlSearchParams) {
	const queryString = urlSearchParams.toString();

	let url = baseUrl;

	if (queryString.length) {
		url += '?' + queryString;
	}

	return url;
}

export function getQueryText($queryTextInput) {
	return $queryTextInput?.val()?.trim() ?? '';
}
